module.exports = __webpack_public_path__ + "static/media/icon_instagram.3d9bfa5a.svg";